<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row class="my-2">
        <b-col cols="12">
          <h1 class="text-uppercase font-weight-bold">Listado de guías de despacho de exportación</h1>
          <plano ref="plano" :plain_file="plain_file"></plano>
          <v-server-table :url="url" :columns="columns" :options="options" :theme="theme" ref="table" id="dataTable">
            <template slot="afterFilter">
              <tr class="VueTables__no-results">
                <b-button @click.prevent="resetFilters">Limpiar filtro</b-button>
                <download-excel
                  class="btn"
                  :fetch="fetchData"
                  :fields="json_fields"
                  worksheet="GuiasDespacho"
                  :name="name"
                  :before-generate="startDownload"
                  :before-finish="finishDownload"
                >
                  <b-button>Descargar</b-button>
                </download-excel>
              </tr>

              <tr v-if="loading" class="VueTables__no-results">
                <b-spinner v-if="loading" variant="primary" class="ml-2 mt-1" small label="Small Spinner"></b-spinner>
              </tr>
            </template>

            <div class="text-right" slot="actions" slot-scope="props">
              <a
                target="_blank"
                href="#"
                @click.prevent="downloadWithAxios(props.row.waybill.id, props.row.waybill.number)"
                class="fa fa-lg fa fa-list text-primary"
                title="Packing List"
              ></a
              >&nbsp;
              <a
                target="_blank"
                href="#"
                @click.prevent="mostrarArchivoPlano(props.row.waybill.id)"
                class="fa fa-lg fa-code text-primary pr-1"
                title="Archivo Plano"
              ></a>
              <a
                title="ver estiba"
                target="_blank"
                href="#"
                @click.prevent="
                  stowageModal(
                    props.row.waybill.id,
                    props.row.shipment.id,
                    props.row.waybill.number,
                    props.row.waybill.waybill_date
                  )
                "
                class="fa fa-lg fa-cube text-primary"
              ></a
              >&nbsp;
              <a
                target="_blank"
                href="#"
                @click.prevent="edit(props.row)"
                class="fa fa-lg fa-edit text-primary"
                title="Editar"
              ></a
              >&nbsp;
              <!--            <a target="_blank" @click.prevent="deleteWaybill(props.row.id)" href="#" class="fa fa-lg fa-trash text-danger" title="Eliminar"></a>-->
            </div>

            <div class="text-right" slot="waybill.waybill_date" slot-scope="props">
              {{ props.row.waybill.waybill_date | date_format }}
            </div>
          </v-server-table>

          <b-modal
            v-model="modalShownBordingInstructive"
            centered
            size="lg"
            title="Instructivos de embarque"
            hide-footer
          >
            <component :is="componenteActual" :idBording="idBording" :shipment="shipment" :ref="report"></component>
          </b-modal>
        </b-col>
      </b-row>
    </div>

    <b-modal ref="modalEstiba" centered size="xl" title="Estiba" @ok="closeModal" ok-only>
      <ReportStowage
        :waybill="waybill"
        :waybill_number="waybill_number"
        :waybill_date="waybill_date"
        :shipment_id="shipment_id"
      ></ReportStowage>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import ReportInstructivoEmbarqueMaritimo from "../ReportInstructivoEmbarqueMaritimo.vue";
import ReportInstructivoEmbarqueAereo from "../ReportInstructivoEmbarqueAereo.vue";
import ReportFacturaExportacion from "../ReportFacturaExportacion.vue";
import ReportStowage from "./ReportStowage.vue";
import Plano from "../Plano.vue";
import numeral from "numeral";
import locales from "numeral/locales";

import JsonExcel from "vue-json-excel";
import moment from "moment";

Vue.component("downloadExcel", JsonExcel);

window.axios = require("axios");

Vue.use(ServerTable);

export default {
  name: "ListGuiaExportacion",
  components: {
    ServerTable,
    ReportInstructivoEmbarqueMaritimo,
    ReportInstructivoEmbarqueAereo,
    Plano,
    ReportFacturaExportacion,
    ReportStowage
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });
  },
  props: [],
  data() {
    return {
      waybill: "",
      waybill_number: "",
      waybill_date: "",
      shipment_id: "",
      loading: false,
      plain_file: {
        filename: "",
        header: "",
        pallets: {}
      },
      loading: false,
      modalShownBordingInstructive: false,
      idBording: 0,
      shipment: "",
      componenteActual: "",
      report: "",
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        Numero: "waybill"
      },
      columns: [
        // 'id',
        "waybill.number",
        "waybill.waybill_date",
        "shipment.boarding_number",
        "vgm",
        "sag_sheet",
        "sag_worker.get_full_name",
        "actions"
      ],
      data: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            /* results[key].waybill_date = moment(results[key].waybill_date).format('DD-MM-YYYY');
              results[key].total_kilograms = numeral(parseFloat(results[key].total_kilograms)); */
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          noResults: "No se encontraron registros.",
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        debounce: 700,
        // columnsDropdown: true,
        filterByColumn: true,
        filterable: ["waybill.number", "waybill.waybill_date", "shipment.boarding_number", "sag_sheet"],
        headings: {
          "waybill.number": "Numero",
          "waybill.waybill_date": "Fecha",
          "shipment.boarding_number": "Embarque",
          vgm: "Vgm",
          sag_sheet: "Planilla SAG",
          "sag_worker.get_full_name": "Contraparte SAG",
          actions: "Acciones"
        },
        sortable: [],
        sortIcon: { base: "fa", up: "fa-sort-asc", down: "fa-sort-desc", is: "fa-sort" },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      },
      json_fields2: {
        Numero: "waybill.number",
        Embarque: "shipment.boarding_number",
        Vgm: {
          field: "vgm",
          callback: (value) => {
            return numeral(parseFloat(value)).format("0.00");
          }
        },
        "Planilla SAG": "sag_sheet",
        "Contraparte SAG": "sag_worker.get_full_name"
      }
    };
  },
  filters: {
    date_format(value) {
      return moment(value).format("DD-MM-YYYY");
    }
  },
  computed: {
    url() {
      return "/api/comex/export_waybill/detailed/";
    },
    name() {
      return "GuiasExportacion " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls";
    }
  },
  methods: {
    resetFilters() {
      for (var key in this.$refs["table"].query) {
        this.$refs["table"].query[key] = "";
      }
      this.$refs["table"].refresh();
    },
    closeModal() {
      this.$refs.modalEstiba.hide();
    },
    stowageModal(waybillExport, shipmentId, waybillnumber, waybilldate) {
      this.waybill = waybillExport;
      this.shipment_id = shipmentId;
      this.waybill_number = waybillnumber;
      (this.waybill_date = waybilldate), this.$refs.modalEstiba.show();
    },
    async fetchData() {
      const response = await this.$axios.get("/api/comex/export_waybill/detailed/");

      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },

    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Packing List - Guia #" + a + ".xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    downloadWithAxios(a, b) {
      this.loading = true;
      this.$axios({
        method: "get",
        url: "/api/comex/export_waybill/" + a + "/packing_list/",
        responseType: "arraybuffer"
      })
        .then((response) => {
          this.forceFileDownload(response, b);
          this.loading = false;
          this.$bvToast.toast("Descargado con éxito", {
            title: "Descarga",
            variant: "success",
            solid: true
          });
        })
        .catch(() => {
          this.loading = false;
          this.$bvToast.toast("Error al descargar", {
            title: "Descarga",
            variant: "danger",
            solid: true
          });
          console.log("error occured");
        });
    },

    mostrarArchivoPlano(a) {
      this.$axios
        .get("/api/comex/export_waybill/" + a + "/plain_file/")
        .then((res) => {
          this.plain_file.filename = res.data.plain_file.filename;
          this.plain_file.header = res.data.plain_file.header;
          this.plain_file.pallets = res.data.plain_file.pallets;
        })
        .catch((error) => {
          this.plain_file.filename = "ERROR";
          this.plain_file.header = "ERROR";
          this.plain_file.pallets = "ERROR";
          console.log(error);
        });
      this.$refs.plano.showModal();
    },
    status(shipment_status) {
      return shipment_status === 2 ? "DESPACHADO" : "ABIERTO";
    },
    getBadge(shipment_status) {
      return shipment_status === 2 ? "dark" : "light";
    },
    showBoardinInstructiveModal(a) {
      //es maritimo
      if (a.shipment_type.id == 1) {
        this.modalShownBordingInstructive = true;
        this.idBording = a.id;
        this.shipment = a;
        this.componenteActual = "ReportInstructivoEmbarqueMaritimo";

        this.report = "report";
        this.$nextTick(function () {
          this.$refs.report.calcular();
        });
      }

      //es aereo
      if (a.shipment_type.id == 2) {
        this.modalShownBordingInstructive = true;
        this.idBording = a.id;
        this.shipment = a;
        this.componenteActual = "ReportInstructivoEmbarqueAereo";

        this.report = "report";
        this.$nextTick(function () {
          this.$refs.report.calcular();
        });
      }
    },
    showExportInvoiceModal(a) {
      this.modalShownBordingInstructive = true;
      this.idBording = a.id;
      this.shipment = a;
      this.componenteActual = "ReportFacturaExportacion";

      this.report = "report";
      this.$nextTick(function () {
        this.$refs.report.calcular();
      });
    },
    edit(row) {
      this.$router.push("/exportaciones/editar-guia-exportacion/" + row.waybill.id);
    },
    onComplete() {}
  },
  beforeMount() {}
};
</script>

<style>
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }

  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
    padding: 0.25rem;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
